import { render, staticRenderFns } from "./PaginatedContainer.vue?vue&type=template&id=4ee69b35&"
import script from "./PaginatedContainer.vue?vue&type=script&lang=ts&"
export * from "./PaginatedContainer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports